import React from 'react';

export const GroundingOpener = ({ text }) => (
  <div className="mb-8 text-center" data-testid="grounding-opener">
    <div className="w-2 h-2 rounded-full mx-auto mb-4" style={{ background: '#8fa9be', boxShadow: '0 0 12px rgba(143,169,190,0.7)' }} />
    <p className="text-base leading-relaxed italic" style={{ fontFamily: 'Playfair Display, serif', color: '#3C3C50' }}>
      {text}
    </p>
  </div>
);

export const QuestNarrative = ({ text }) => (
  <p className="text-lg leading-relaxed mb-8" style={{ fontFamily: 'Playfair Display, serif', color: '#2E2E42' }} data-testid="quest-narrative">
    {text}
  </p>
);

export const ExitRampBanner = ({ text }) => (
  <div
    className="p-4 rounded-xl mb-6"
    style={{ background: 'rgba(143,169,190,0.1)', border: '1px solid rgba(143,169,190,0.25)' }}
    data-testid="exit-ramp-banner"
  >
    <p className="text-sm leading-relaxed" style={{ fontFamily: 'Jost, sans-serif', color: '#a8bfd1' }}>
      {text}
    </p>
  </div>
);

export const PromptCard = ({ promptText, value, onChange, disabled }) => (
  <div className="p-5 rounded-2xl mb-6" style={{ background: '#F7F1EE' }} data-testid="prompt-card">
    <p className="text-base leading-relaxed mb-4" style={{ fontFamily: 'Playfair Display, serif', color: '#A9756B' }}>
      {promptText}
    </p>
    <textarea
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      rows={5}
      placeholder="Whatever comes is enough..."
      className="w-full p-4 rounded-xl text-sm leading-relaxed resize-none focus:outline-none"
      style={{
        background: 'rgba(26,26,46,0.08)',
        color: '#1A1A2E',
        fontFamily: 'Jost, sans-serif',
        border: '1px solid #F0EBE4',
      }}
      data-testid="prompt-input"
    />
  </div>
);

export const ReintegrationCloser = ({ text, lightAwarded, newlyUnlocked, realms, keepsakeIncluded, onToggleKeepsake, keepsakeCreated, onContinue }) => (
  <div className="text-center py-6" data-testid="reintegration-closer">
    <div
      className="w-14 h-14 rounded-full mx-auto mb-6 flex items-center justify-center"
      style={{ background: 'radial-gradient(circle, rgba(201,168,76,0.6) 0%, rgba(201,168,76,0.15) 100%)', boxShadow: '0 0 30px rgba(201,168,76,0.4)' }}
    >
      <div className="w-4 h-4 rounded-full" style={{ background: '#C9A84C', boxShadow: '0 0 12px rgba(201,168,76,0.9)' }} />
    </div>
    <p className="text-lg leading-relaxed mb-4" style={{ fontFamily: 'Playfair Display, serif', color: '#1A1A2E' }}>
      {text}
    </p>
    <p className="text-xs tracking-[0.15em] mb-2" style={{ fontFamily: 'Jost, sans-serif', color: '#C9A84C' }} data-testid="light-awarded">
      +{lightAwarded} LIGHT
    </p>
    {newlyUnlocked?.length > 0 && (
      <p className="text-sm mb-4" style={{ fontFamily: 'Jost, sans-serif', color: '#72826F' }} data-testid="realm-unlocked-message">
        A new place has opened for you: {newlyUnlocked.map((r) => realms?.[String(r)]?.name || `Realm ${r}`).join(', ')}
      </p>
    )}
    {keepsakeCreated && (
      <p className="text-sm mb-4" style={{ fontFamily: 'Jost, sans-serif', color: '#C9A84C' }} data-testid="keepsake-created-message">
        A new chapter of your Book of Becoming is ready.
      </p>
    )}
    {onToggleKeepsake && (
      <button
        onClick={onToggleKeepsake}
        className="flex items-center gap-2 mx-auto mt-2 mb-2 px-4 py-2 rounded-full text-xs tracking-[0.06em] transition-all active:scale-95"
        style={{
          background: keepsakeIncluded ? 'rgba(201,168,76,0.2)' : '#F7F1EE',
          color: keepsakeIncluded ? '#C9A84C' : '#5C5968',
          fontFamily: 'Jost, sans-serif',
          border: keepsakeIncluded ? '1px solid rgba(201,168,76,0.35)' : '1px solid transparent',
        }}
        data-testid="keepsake-toggle-button"
      >
        <svg width="13" height="13" viewBox="0 0 24 24" fill={keepsakeIncluded ? '#C9A84C' : 'none'} stroke="currentColor" strokeWidth="1.5">
          <path d="M4 19.5A2.5 2.5 0 016.5 17H20V4H6.5A2.5 2.5 0 004 6.5v13z" strokeLinejoin="round" />
        </svg>
        {keepsakeIncluded ? 'Kept in your Book of Becoming' : 'Keep this in your Book of Becoming'}
      </button>
    )}
    <button
      onClick={onContinue}
      className="mt-4 px-8 py-3 rounded-full text-sm tracking-[0.1em] transition-all active:scale-95"
      style={{ background: 'rgba(201,168,76,0.15)', color: '#C9A84C', fontFamily: 'Jost, sans-serif' }}
      data-testid="closer-continue-button"
    >
      RETURN TO THE MAP
    </button>
  </div>
);
